function NavBar() {
  return (
    <i className="center-container style-navbar">
      Thiruvalluvar.AI: World’s First Tamil-English Bilingual AI based on Thiruvalluvar © 2024 – Whitchurch Muthumani{" "}
      |{" "}
      <a
        href="/origin"
        style={{
          color: "#7ED6CA",
          textDecoration: "none",
          fontStyle: "normal"
        }}
      >
        Origin
      </a>
    </i>
  );
}

export default NavBar;
